import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import share_btn from './share_btn.png';

class GlobalNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        curTime: '',
        title: '',
    };

    box = React.createRef();

    getShare = item => {
        const { shareUrl, url, title, id, thumbnail, summary, newsTime } = item;

        if (window.grounds) {
            // window.grounds.openShare(
            //     url,
            //     tit,
            //     '',
            //     'https://p0.ifengimg.com/2019_19/7812F0690848DF15F2FA0248CE701CA0A823E558_w300_h300.png',
            //     0,
            // );

            window.grounds.newShare(
                JSON.stringify({
                    shareurl: shareUrl || url,
                    title,
                    desc: '',
                    thumbnail: '',
                    cardType: 'finance',
                    timestamp: newsTime ? String(new Date(newsTime.replace(/-/g, '/')).getTime()) : '',
                    documentId: id || '',
                }),
            );
        }
    };

    handleClick = (type, id, url) => {
        let _type = '';
        let _id = id;

        if (type === 'article') {
            _type = 'doc';
            _id = `ucms_${_id}`;
        } else if (type === 'video' || type === 'miniVideo') {
            _type = 'phvideo';
            _id = `video_${_id}`;
        } else if (type === 'slide') {
            _type = 'slide';
            _id = `slide_${_id}`;
        }

        // 文章是否发布
        if (url) {
            if (window.grounds && _type) {
                window.grounds.dispatch(_type, _id);
            } else {
                window.location.href = url;
            }
        }
    };

    // getMore = () => {
    //     this.setState({
    //         newsLen: this.state.newsLen + 10,
    //     });
    // };

    // componentDidMount() {
    //     const documentWidth = document.documentElement.clientWidth;
    //     const onPullUpTop = this.box.current.offsetTop + (documentWidth * 180) / 750;

    //     window.addEventListener('scroll', () => {
    //         this.handleScroll(onPullUpTop);
    //     });
    // }

    // handleScroll = onPullUpTop => {
    //     const onPullUpHeight = this.box.current.clientHeight;
    //     const documentHeight = document.documentElement.clientHeight;
    //     const documentTop = document.body.scrollTop || document.documentElement.scrollTop;

    //     if (onPullUpHeight > documentHeight && onPullUpHeight <= documentHeight + documentTop - onPullUpTop + 50) {
    //         this.getMore();
    //     }
    // };

    render() {
        const { content } = this.props;

        // console.log(content);

        // const curDate = new Date().getTime();
        // const prevDate = curDate - 24 * 60 * 60 * 1000 * 2;
        let oldTime = '';

        // const newArr = content.filter(item => {
        //     const newDate = new Date(item.newsTime.replace(/-/g, '/')).getTime();

        //     if (newDate >= prevDate && newDate <= curDate) {
        //         return item;
        //     } else {
        //         return false;
        //     }
        // });

        return (
            <div className={styles.global_list} ref={this.box}>
                {content.map((item, index) => {
                    const curTime = item.newsTime;
                    const nowTime = curTime.slice(0, 10);
                    const time = curTime.slice(curTime.indexOf(' '));
                    const title = item.title;
                    const url = item.url;
                    const id = item.id;
                    const type = item.type;

                    if (nowTime !== oldTime) {
                        oldTime = nowTime;

                        return (
                            <React.Fragment key={index}>
                                <div className={styles.new_date} data-groupdate={nowTime}>
                                    <span>{`${nowTime.slice(0, 4)}年${nowTime.slice(5, 7)}月${nowTime.slice(
                                        8,
                                    )}日`}</span>
                                </div>
                                <div className={styles.new_box} key={index} data-newsdate={curTime}>
                                    <div className={styles.new_box_bor}>
                                        <div className={styles.new_time}>{time}</div>
                                        <div className={styles.new_txt}>
                                            <a onClick={() => this.handleClick(type, id, url)}>{title}</a>
                                        </div>
                                        <div className={styles.new_bot}>
                                            {window.grounds &&
                                                url && (
                                                    <div
                                                        className={styles.share_btn}
                                                        onClick={() => this.getShare(item)}>
                                                        <img src={share_btn} alt="" />
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        );
                    } else {
                        return (
                            <div className={styles.new_box} key={index} data-newsdate={curTime}>
                                <div className={styles.new_box_bor}>
                                    <div className={styles.new_time}>{time}</div>
                                    <div className={styles.new_txt}>
                                        <a onClick={() => this.handleClick(type, id, url)}>{title}</a>
                                    </div>
                                    <div className={styles.new_bot}>
                                        {window.grounds &&
                                            url && (
                                                <div className={styles.share_btn} onClick={() => this.getShare(item)}>
                                                    <img src={share_btn} alt="" />
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </div>
                        );
                    }
                })}
            </div>
        );
    }
}

export default errorBoundary(GlobalNews);
